import api from "./api"

const webhookService = {
  getWebhooksByOrganization: (organizationId) => {
    return api.get(`/webhooks/organization/${organizationId}`)
  },

  getWebhook: (webhookId) => {
    return api.get(`/webhooks/${webhookId}`)
  },

  createWebhook: (webhookData, params = {}) => {
    return api.post("/webhooks", webhookData, { params })
  },

  updateWebhook: (webhookId, webhookData) => {
    return api.put(`/webhooks/${webhookId}`, webhookData)
  },

  deleteWebhook: (webhookId) => {
    return api.delete(`/webhooks/${webhookId}`)
  },

  getWebhookEvents: () => {
    return api.get("/webhooks/events")
  },

  testWebhook: (webhookId, payload) => {
    return api.post(`/webhooks/test/${webhookId}`, payload ? { payload } : {})
  },

  getWebhookDeliveries: (webhookId, page = 1, limit = 10) => {
    return api.get(`/webhooks/${webhookId}/deliveries?page=${page}&limit=${limit}`)
  },

  testWebhookEndpoint: (webhookData, payload) => {
    return api.post("/webhooks/test-endpoint", { webhook: webhookData, payload })
  },
}

export default webhookService

